import { UUID } from "../generic/uuid";
import {
  createOrganisationDtoFromAdminOrganisationModel,
  OrganisationModel,
} from "./organisation";
import { ContactPointModel } from "./contactPoint";
import { SupplierDto } from "@vini-wine/core-dtos";
import { SupplierStatusEnum } from "@vini-wine/core-enums";

export interface SupplierModel extends UUID {
  // transform
  isCustomer: boolean;
  name: string;
  createdAt: Date;
  status: {
    id: SupplierStatusEnum;
  };

  // available includes
  supplierOrganisation?: OrganisationModel;
  organisation?: OrganisationModel;
  primaryLogisticsContactPoint?: ContactPointModel | null;
  primarySalesContactPoint?: ContactPointModel | null;
}

export const createSupplierDtoFromAdminSupplierModel = (
  supplier: SupplierModel,
): SupplierDto => {
  return {
    name: supplier.name,
    uuid: supplier.uuid,
    supplierOrganisation: supplier.supplierOrganisation
      ? createOrganisationDtoFromAdminOrganisationModel(
          supplier.supplierOrganisation,
        )
      : undefined,
  };
};
